import { render } from "./IconTick.vue?vue&type=template&id=5c50f90c"
const script = {}

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__